/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

  $(document).ready(function() {

if($('div').is('.CollectionMain')){
          var header_position=$(".CollectionMain").position().top;

        $(window).scroll(function() {
          var scroll = $(window).scrollTop();
          if (scroll > 0 ) {
            $(".CollectionToolbar").addClass("filter-sticky");
          } else {
            $(".CollectionToolbar").removeClass("filter-sticky");
          }
        });
}
	  });

$(document).ready(function(){
	 $('.cm_table').click(function(){
		$(this).addClass('redColor');
		 $('.inch_table').removeClass('redColor');
		$('.size_cm').addClass('size_active');
		$('.size_inch').removeClass('size_active');
	  });
	  $('.inch_table').click(function(){
		$(this).addClass('redColor');
		 $('.cm_table').removeClass('redColor');
		$('.size_inch').addClass('size_active');
		$('.size_cm').removeClass('size_active');
	  });
	  
});
/**
 $(document).ready(function() {
    $('body').on('click', '.Cart__Checkout', function() {
      if ($('#agree').is(':checked')) {
        $(this).attr("name","checkout");
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });*/

/* gtag manager event */
$(document).ready(function(){
  if(typeof(window.dataLayer) != 'undefined'){
    $('.gtag-search').on('click',function(){
      var q = $('.gtag-search').parents('form').find('input[name="q"]').val();
      window.dataLayer.push({
        "event": "search",
        "search_term": q
      })
      console.log('gtag search',q)
    })

    $('form.Search__Form input[name="q"]').on("keyup change", function(e) {
      var q = $(this).val();
      window.dataLayer.push({
        "event": "search",
        "search_term": q
      })
      console.log('gtag search',q)
    })
  
    $('.gtag-login').on('click',function(){
      window.dataLayer.push({
        "event": "login"
      })
      console.log('gtag login')
    })
  
    $('.gtag-signup').on('click',function(){
      window.dataLayer.push({
        "event": "sign_up"
      })
      console.log('gtag sign_up')
    })
  
    $('.gtag-subscribe').on('click',function(){
      window.dataLayer.push({
        "event": "newsletter_subscription"
      })
      console.log('gtag newsletter_subscription')
    })

    $('.gtag-addtocart').on('click',function(){
      var add_param = {
        "event": "add_to_cart",
        "items": [
          {
            "item_id": "shopify_gb_"+$(this).data('product-id')+"_"+$(this).data('variant-id'),
            "item_name": $(this).data('product-title'),
            "price": $(this).data('product-price'),
            "item_category": ""
          }
        ],
        "value":  $(this).data('product-price'),
        "currency": $(this).data('product-currency'),
      }
      window.dataLayer.push(add_param)
      console.log('gtag addToCart',add_param)
    })

    if($('.template-product').length>0 && $('.gtag-addtocart').length>0){
      var addtocartobj = $('.gtag-addtocart');
      var view_param = {
        "event": "view_item",
        "items": [
          {
            "item_id": "shopify_gb_"+addtocartobj.data('product-id')+"_"+addtocartobj.data('variant-id'),
            "item_name": addtocartobj.data('product-title'),
            "price": addtocartobj.data('product-price'),
            "item_category": ""
          }
        ],
        "value":  addtocartobj.data('product-price'),
        "currency": addtocartobj.data('product-currency'),
      }
      window.dataLayer.push(view_param)
      console.log('gtag view_item',view_param)
    }
    
    $('.gtag-buyitnow').on('click',function(){
      var product_checkout_param = {
        "event": "begin_checkout",
        "items": [
          {
            "item_id": $(this).data('variant-sku'),
            "item_name": $(this).data('product-title'),
            "price": $(this).data('product-price'),
            "quantity": $("#quantity").val(),
            "item_category": ""
          }
        ],
        "value":  $(this).data('product-price'),
        "currency": $(this).data('product-currency'),
      }
      window.dataLayer.push(checkout_param)
      console.log('gtag product begin_checkout',checkout_param)
    })

    $(".gtag-checkout").on('click',function(){
       var checkoutItems = $(this).data('checkout-items')
       var items = $.map(checkoutItems, function (i) {
          return {
              "item_id": "shopify_gb_"+i.product_id+"_"+i.id,
              "item_name": i.product_title,
              "price": (i.price * 100)/10000,
              "quantity": i.quantity,
              "item_category": ""
            }
      });
      console.log('items',items)
      
      var cart_checkout_param = {
        "event": "begin_checkout",
        "items": items,
        "value":  $(this).data('checkout-total'),
        "currency": $(this).data('checkout-currency'),
      }
      window.dataLayer.push(cart_checkout_param)
      console.log('gtag cart begin_checkout',cart_checkout_param)
    })
  }
})
